export const REQUEST_CATEGORY_ITEMS = 'REQUEST_CATEGORY_ITEMS';
export const RECEIVE_CATEGORY_ITEMS = 'RECEIVE_CATEGORY_ITEMS';
export const RECEIVE_CATEGORY_DATA = 'RECEIVE_CATEGORY_DATA';
export const UPDATE_WITHOUT_REQUEST = 'UPDATE_WITHOUT_REQUEST';
export const GET_CATEGORY_DATA = 'GET_CATEGORY_DATA';

export function requestCategoryItems(requestType = null, component, e) {
    return {
        type: REQUEST_CATEGORY_ITEMS,
        payload: {
            requestType: requestType
        },
        meta: {
            event: e,
            component: component
        }
    };
}

export function receiveCategoryItems(data, categoryId, searchTerm, requestedPage, sortOptions, qs = '') {
    return {
        type: RECEIVE_CATEGORY_ITEMS,
        payload: {
            data: data,
            categoryId: categoryId,
            searchTerm: searchTerm,
            isSearch: !!searchTerm,
            requestedPage: requestedPage,
            sortOptions: sortOptions,
            queryString: qs,
            receivedAt: Date.now()
        }
    };
}

/**
 * Receives new category data to be inserted in the category
 *  store section
 * @param {Object} data - category data (from orchestration call)
 * @returns {Object} category data
 */
export function receiveCategoryData(data) {
    return {
        type: RECEIVE_CATEGORY_DATA,
        payload: {
            category: data.category
        }
    };
}

export function updateWithoutRequest(data, categoryId, searchTerm, currentPage, qs = '') {
    return {
        type: UPDATE_WITHOUT_REQUEST,
        payload: {
            data: data,
            categoryId: categoryId,
            searchTerm: searchTerm,
            isSearch: !!searchTerm,
            currentPage: currentPage,
            queryString: qs,
            receivedAt: Date.now()
        }
    };
}
